import { render, staticRenderFns } from "./Cancel.vue?vue&type=template&id=fe2717f6&scoped=true&"
import script from "./cancel.js?vue&type=script&lang=js&"
export * from "./cancel.js?vue&type=script&lang=js&"
import style0 from "../dialog.scss?vue&type=style&index=0&id=fe2717f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2717f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
